import { render } from "./GoodRow.vue?vue&type=template&id=17445b8a&scoped=true"
import script from "./GoodRow.vue?vue&type=script&lang=js"
export * from "./GoodRow.vue?vue&type=script&lang=js"

import "./GoodRow.vue?vue&type=style&index=0&id=17445b8a&scoped=true&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17445b8a"]])

export default __exports__